<!------------------------------------------------------------------------------
 File: BaseJsonView 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 22/10/2018
 Time: 10:40
------------------------------------------------------------------------------->
<template>
    <div class="d-flex justify-content-start align-items-center"
         :data-wrapper="start_wrapper"
         :class="{
            start_wrapper:start_wrapper != ''
         }"
         :data-json_counter="json_counter"
    >
        <BaseTab v-if="json_counter>0" :side_border="true"></BaseTab>

        <ul class="list-unstyled m-0 w-100"
            :data-item-counter="json_counter"
            :class="'json_counter_'+json_counter"
            >
            <li v-for="item,index,counter in json" class="">
                <details :data-counter="counter"
                         class="json-group"

                >
                    <summary class="json-group--prop">
                        <code>{{index}}:

                            <span v-if="isObject(item)"
                                  class="json-group--code_open">
                                {
                            </span>
                        </code>


                        <code v-if="!isObject(item)"
                              :data-this-counter="counter"
                              :data-length="lengthObj(json)"
                              class="json-group--value bg-black"
                        >{{item}}

                            <span v-if="counter < lengthObj(json) - 1">,</span>
                        </code>
                    </summary>

                    <BaseJsonView class="json-group--value"
                                  v-if="isObject(item)"
                                  :json="item"
                                  :json_counter="counter"></BaseJsonView>

                </details>
                <code class="json-group--code_close" v-if="isObject(item)">},</code>
            </li>

        </ul>
    </div>
</template>

<script>
    import { length as ObjLength } from '../../helpers/object.formats';

    export default {
        name: 'BaseJsonView',
        components: {},
        props: {
            start_wrapper: {
                default: ''
            },
            json: {
                type: Object | Array
            },
            json_counter: {
                type: Number
            }
        },
        created() {},
        destroyed() {},
        mounted() {

        },
        data() {
            return {};
        },
        methods: {
            isObject(item) {
                if (item !== null && typeof item === 'object') {
                    return true;
                }
                return item !== null && typeof item === 'object';
            },
            lengthObj(item) {
                return ObjLength(item);
            }
        },
        watch: {},
        computed: {}
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseJsonView.vue?d42706e0